var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBookmarkSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_Bookmark_-_Selected",
    width: 24,
    height: 24,
    "data-name": "Icon - Bookmark - Selected",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}.prefix__cls-3{fill:none}.prefix__cls-5{stroke:none}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_Bookmark_-_Selected-2",
    "data-name": "Icon - Bookmark - Selected",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0H20V16H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3609",
    "data-name": "Group 3609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Path_6228",
    fill: "none",
    strokeMiterlimit: 10,
    "data-name": "Path 6228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0v7.361A1.251 1.251 0 0 0 13.879 8.4l1.454-.813 1.454.813a1.251 1.251 0 0 0 1.879-1.038V1.6A1.634 1.634 0 0 0 17 0z",
    className: "prefix__cls-5",
    transform: "translate(-2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed148",
    d: "M13.5 1.5v5.392l1.101-.616.732-.409.732.41 1.102.615V1.6c0-.034-.06-.1-.167-.1h-3.5M12 0h5c.92 0 1.667.716 1.667 1.6v5.76c0 .702-.6 1.203-1.253 1.203-.21 0-.424-.052-.626-.165l-1.455-.812-1.454.812c-.202.113-.417.165-.626.165C12.6 8.563 12 8.062 12 7.361V0z",
    transform: "translate(-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6224",
    d: "M12 2v7.2a1.5 1.5 0 0 0 2.255 1.3L16 9.482l1.745 1.018A1.5 1.5 0 0 0 20 9.2V2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2z",
    className: "prefix__cls-3",
    "data-name": "Path 6224",
    transform: "translate(-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Rectangle_1786",
    fill: "none",
    stroke: "#22b560",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    "data-name": "Rectangle 1786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.999,
    height: 16,
    className: "prefix__cls-5",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.999,
    height: 14,
    x: 1,
    y: 1,
    className: "prefix__cls-3",
    rx: 4
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkSelected);
export default __webpack_public_path__ + "static/media/icon-bookmark-selected.f7509d8278575d148a6db8776afb0c26.svg";
export { ForwardRef as ReactComponent };